module.exports = __webpack_public_path__ + "images/shimo/slide-grid-4650f01b5c493008b63242c0d3acf0b7.png";